export default __webpack_public_path__ + "static/support-cc5752a84a48610e6293c821a0c8f478.png";